export default {
    methods:{
        DateFormatText(dateText){
            var dia = dateText.substring(8,10);
            var mes = dateText.substring(5,7);
            var anio = dateText.substring(0,4);
            var mesCadena = this.string_mes(mes);
            var fecha_procesada = dia + ' de ' + mesCadena + ' de ' + anio;
            let texto_completo = `  <div class="d-flex justify-content-end text-fecha">
                                        <span class="resaltado">Actualizado al </span> <span class="ml-1">${fecha_procesada}</span>
                                    </div>`
            return texto_completo;
        },
        string_mes(mes){
            if(mes==1) return 'Enero'; if(mes==2) return 'Febrero'; if(mes==3) return 'Marzo'; if(mes==4) return 'Abril';
            if(mes==5) return 'Mayo'; if(mes==6) return 'Junio'; if(mes==7) return 'Julio'; if(mes==8) return 'Agosto';
            if(mes==9) return 'Septiembre'; if(mes==10) return 'Octubre'; if(mes==11) return 'Noviembre'; if(mes==12) return 'Diciembre';
        },

        /** devuelve la fecha mas actual de un array de objeto**/
        mixin_fecha_actual(data){
          let fecha = new Date('1900/01/01'); // <---pongo una fecha inicial q sera sustituida inmediatamente
          let fecha_actual = '';
          data.forEach(e =>{
            if(new Date(e.fecha_actualizacion) > fecha ){
              fecha = new Date(e.fecha_actualizacion);
              fecha_actual = e.fecha_actualizacion;
            }
          });
          return fecha_actual;
        }

        /** ejemplo de data para mixin_fecha_actual.
         * UNICO ATRIBUTO INDISPENSABLE: "fecha_actualizacion"
         * [
            {
              "id": 1,
              "anio": 0,
              "titulo": "2. Proyecto del Presupuesto de Egresos",
              "fecha_actualizacion": "2021-02-22",
              "contenido": []
            },
            {
              "id": 2,
              "anio": 0,
              "titulo": "5 Calendario del Presupuesto de Egresos base mensual",
              "fecha_actualizacion": "2021-02-22",
              "contenido": []
            }
          ]
*/


    },
  };
